<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWMODULE')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('MODULENAME')">
                <inputvalidation :formerror="formError" name="moduleName"><b-form-input type="text" v-model="formData.moduleName" v-bind:placeholder="$t('MODULENAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('TABLENAME')">
                <inputvalidation :formerror="formError" name="tableName"><b-form-input type="text" v-model="formData.tableName" v-bind:placeholder="$t('TABLENAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <strong>{{$t('NEWFIELD')}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('NAME')">
                <b-form-input type="text" v-model="field.name" v-bind:placeholder="$t('NAME')"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('PRIMARY')">
                <b-form-checkbox :plain="true" v-model="field.primary" value="1">{{$t('PRIMARY')}}</b-form-checkbox>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('REQUIRED')">
                <b-form-checkbox :plain="true" v-model="field.required" value="1">{{$t('REQUIRED')}}</b-form-checkbox>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('NULL')">
                <b-form-checkbox :plain="true" v-model="field.null" value="1">{{$t('NULL')}}</b-form-checkbox>
              </b-form-fieldset>
            </div>

            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('FIELDTYPE')">
                <b-form-select v-model="field.fieldType" :options="fieldTypes"></b-form-select>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('MAXLENGTH')">
                <b-form-input type="text" v-model="field.maxLength" v-bind:placeholder="$t('MAXLENGTH')"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('MINLENGTH')">
                <b-form-input type="text" v-model="field.minLength" v-bind:placeholder="$t('MINLENGTH')"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('MAXVALUE')">
                <b-form-input type="text" v-model="field.maxValue" v-bind:placeholder="$t('MAXVALUE')"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('MINVALUE')">
                <b-form-input type="text" v-model="field.minValue" v-bind:placeholder="$t('MINVALUE')"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-3">
              <b-form-fieldset v-bind:label="$t('DECORATORS')">
                <b-form-select v-model="field.decorators" :options="decorators"></b-form-select>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset>
                <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="addField()"><icon name="dot-circle-o"></icon> {{$t('SUBMIT')}}</b-button>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <strong>{{$t('FIELDS')}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th v-for="(value, key) in fields[0]">{{$t(key.toUpperCase())}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in fields">
                    <td v-for="(value, key) in item">{{value}}</td>
                    <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.key)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div slot="footer">
            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow()"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/admin/Generator'

export default {
  name: 'Generator',
  data: function()
  {
    var me = this;

    return {
      field: {},
      fields: [],
      formData:
      {
        moduleName: '',
        tableName: ''
      },
      formError: {},
      fieldTypes:
      [
        {
          value: 'int',
          text: me.$i18n.t('INTEGER')
        },
        {
          value: 'float',
          text: me.$i18n.t('FLOAT')
        },
        {
          value: 'text',
          text: me.$i18n.t('STRING')
        },
        {
          value: 'email',
          text: me.$i18n.t('EMAIL')
        },
        {
          value: 'dateTime',
          text: me.$i18n.t('DATETIME')
        },
        {
          value: 'date',
          text: me.$i18n.t('DATE')
        },
        {
          value: 'time',
          text: me.$i18n.t('TIME')
        }
      ],
      decorators:
      [
        {
          value: 'leaveuntouched',
          text: me.$i18n.t('LEAVEUNTOUCHED')
        },
        {
          value: 'safetrans',
          text: me.$i18n.t('SAFETRANS')
        }
      ]
    }
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      Api.saveModule({formData: me.formData, fields: me.fields}, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
        }
      })
    },
    deleteRow: function(key)
    {
      var me = this;
      me.fields.splice(key, 1);
    },
    addField: function()
    {
      var me = this;
      var obj = Object.assign({}, me.field);
      me.fields.push(obj);
    }
  }
}
</script>
